import { Card, CardHeader, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useStyles } from './SubmitRfpStyle';

const InviteAcceptanceState = (props) => {
  const classes = useStyles();
  return (
    <>
      {
        (props.inviteAcceptanceState.acceptStatus === 1 || props.inviteAcceptanceState.acceptStatus === 2) ? null : (
          <Grid item className=" rfp-breaccrumb roboto-font" md={12} xl={12} lg={12}>
            <Card className="requestly-rfp-view  radius-15 bg-white mb-4">
              <CardHeader
                title="Submit RFP"
                subheader="(Please submit your details)"
                className={classes.companyHeadings + ' requestly-rfp-heading'} />
              <CardHeader className={classes.acceptInviateHeader} title={<Grid container spacing={3} id="panel-Pricingss">
                <Grid item md={12} xs={12}>
                  <Typography> {props.companyState.companyName} has invited you to participate in their Title {props.projectState.projectName} </Typography>
                </Grid>
                <Grid item md={12} xs={12}>
                  <Typography> Please accept or decline the invite. </Typography>
                </Grid>
                <div style={{ "width": "100%", "display": "block", }} className={classes.customInputs}>
                  <Grid item md={12} xs={12} style={{ "width": "100%", "display": "block", }}>
                    <Button style={{ "padding": "6px 16px", "fontSize": "13px" }} className={classes.redBtn} color="secondary" variant="contained" type="button" onClick={() => props.updateState(2)}>
                      {props.inviteAcceptanceState.acceptStatus === 2 ? 'Declined' : 'Decline'}
                    </Button>
                    <Button style={{ "padding": "6px 16px", "fontSize": "13px", "float": "right" }} className={classes.blueBtn} color="secondary" variant="contained" type="button" onClick={() => props.updateState(1)}>
                      {props.inviteAcceptanceState.acceptStatus === 1 ? 'Accepted' : 'Accept'}
                    </Button>
                  </Grid>
                </div>
              </Grid>} />
            </Card></Grid>)

      }
    </>
  );
};


export default InviteAcceptanceState;
